import { format } from 'date-fns'

import CalendarIcon from '@/assets/icons/icon-calendar.svg'
import { Button } from '@/components/ui/button.tsx'
import { Calendar } from '@/components/ui/calendar/calendar.tsx'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover.tsx'
import { classNames } from '@/utils/helpers'

interface CalendarDatePickerProps {
  date: Date | undefined
  onChange: (value: Date | undefined) => void
  className?: string
  popoverClassName?: string
  fromDate?: Date
  toDate?: Date
  disabled?: boolean
  placeholder?: string
  yearAndMonthSelect?: boolean
  position?: 'top' | 'bottom' | 'left' | 'right'
}

export const CalendarDatePicker = ({
  className,
  popoverClassName,
  date,
  onChange,
  fromDate,
  toDate,
  disabled,
  placeholder = 'Pick a date',
  yearAndMonthSelect,
  position,
}: CalendarDatePickerProps) => {
  const handleMonthChange = (newMonth: Date) => {
    if (!yearAndMonthSelect || !date) {
      return
    }

    const newDate = new Date(date)

    newDate.setFullYear(newMonth.getFullYear())
    newDate.setMonth(newMonth.getMonth())
    onChange(newDate)
  }

  return (
    <div className={classNames('grid gap-2', className)}>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            id="date"
            variant="ghost"
            className={classNames(
              'bg-card text-title flex items-center justify-start gap-1 truncate border text-left font-normal',
              !date && 'text-title',
            )}
            disabled={disabled}
          >
            <CalendarIcon className="h-4 w-4 shrink-0" />
            {date ? format(date, 'LLL dd, y') : <span>{placeholder}</span>}
          </Button>
        </PopoverTrigger>
        <PopoverContent
          className={classNames('z-100 w-auto p-4', popoverClassName)}
          align="start"
          side={position}
        >
          <Calendar
            initialFocus
            mode="single"
            defaultMonth={date}
            onMonthChange={handleMonthChange}
            selected={date}
            onSelect={onChange}
            numberOfMonths={1}
            fromDate={fromDate}
            toDate={toDate}
            {...(yearAndMonthSelect && {
              captionLayout: 'dropdown',
              fromYear: new Date().getFullYear() - 100,
              toYear: new Date().getFullYear(),
            })}
          />
        </PopoverContent>
      </Popover>
    </div>
  )
}
